import useInputWithReset from '../../input-hooks/useInputWithReset'

import { confidentialNotesForm as form } from '../../../forms/form-objects/customerFormObjects'

import {
  getInput,
  getValidation,
  getForm,
  applyOverrides
} from '../../input-hooks/inputFunctions'

const useConfidentialNotesForm = (record, fieldOverrides) => {
  applyOverrides('Customer Notes', form, fieldOverrides)
  const keyArray = Object.keys(form)
  const i = []

  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )

  return getForm(keyArray, i)
}

export default useConfidentialNotesForm
